/**
 * After the org or location changes, load the app fresh for the new scope.
 *
 * A chat belongs to the org and location it was started in, so an open chat
 * goes to the home page; reloading it would leave the old chat's address in
 * the bar, and a later refresh would land on it under the new scope. Other
 * pages reload where they are.
 */
export function reloadForNewScope(loc = window.location) {
  if (loc.pathname.startsWith('/chat/')) loc.assign('/');
  else loc.reload();
}
